import React from 'react';
import { DiscountPanel, MultiPanePanel } from '@vp/component-library';
import PropTypes from 'prop-types';
import useSiteData from '../../../hooks/useSiteData';

export const DiscountModal = ({
  open,
  setIsOpen,
  discounts,
  selectedDiscountId,
}) => {
  const { locale } = useSiteData();
  return (
    <MultiPanePanel
      isOpen={open}
      setIsOpen={setIsOpen}
      locale={locale}
      onlyRenderWhenOpen
    >
      <DiscountPanel
        locale={locale}
        discountSources={discounts}
        selectedDiscountId={selectedDiscountId}
      />
    </MultiPanePanel>
  );
};

DiscountModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  discounts: PropTypes.shape({
    itemDiscounts: PropTypes.array,
    shippingDiscounts: PropTypes.array,
  }).isRequired,
  selectedDiscountId: PropTypes.string.isRequired,
};
